<template>
  <div class="m-1">
    <div class="row justify-content-center">
      <div  class="col-8">
        <div v-if="getCallInfo != null">
          <CallWindow/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

import CallWindow from "@/components/general_user/CallWindow/CallWindow";
import CheckupService from "@/services/checkup.service";

export default {
  name: "Checkup",
  components: {
    CallWindow,
  },
  data: function () {
    return {
      patientcheckup: {},
    }
  },
  computed: {
    ...mapGetters('generalUserCheckup', ['getCallInfo']),
  },
  methods: {
    ...mapActions('generalUserCheckup', ['initializeFirebaseListener', 'setCallInfo']),
    fetchPatientcheckupDetails() {
      CheckupService.fetchPatientCheckupDetails(this.$route.params.patientcheckup_code)
          .then((response) => {
            if (response.status === 200) {
              this.patientcheckup = response.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
    },
    initializeCall() {
      // Request a new token
      CheckupService.makeCheckupCall(this.$route.params.patientcheckup_code, true)
          .then((response) => {
            if (response.status === 201) {
              this.setCallInfo(response.data);
            }
          })
          .catch(function (error) {
            console.log(error);
          })
    },
  },
  mounted() {
    this.fetchPatientcheckupDetails();
    if (this.getCallInfo == null)
      this.initializeCall();
  },
  beforeDestroy() {
    this.setCallInfo(null);
  }
}
</script>

<style src="./Checkup.scss" lang="scss">

</style>
